import {
	Box,
	Divider,
	Grid,
	Hidden,
	Theme,
	Typography,
	createStyles
} from "@material-ui/core";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import Cogs from "components/Cogs";
import DashboardOrders from "components/DashboardOrders/index";
import DashboardProducts from "components/DashboardProductsPerformance";
import DashboardProductsProfit from "components/DashboardProductsProfit";
import DashboardReports from "components/DashboardReports";
import HtmlEditor from "components/HtmlEditor/HtmlEditor";
import Inventory from "components/Inventory";
import Orders from "components/Orders";
import ProfitBreakdown from "components/ProfitBreakdown";
import ReportBusiness from "components/ReportBusiness";
import ReportInventory from "components/ReportInventory";
import NetProfit from "components/SalesVisualization/NetProfit";
import TotalRevenue from "components/SalesVisualization/TotalRevenue";
import StatusBar from "components/StatusBar";
import { TranslationPrefixes } from "consts/translationPrefixes";
import React from "react";
import { useTranslation } from "react-i18next";
import {
	Redirect,
	Route,
	RouteComponentProps,
	Switch,
	withRouter,
} from "react-router-dom";
import twoImg from "../../assets/2.png";
import logoFooter from "../../assets/footer-logo.png";
import logos from "../../assets/logos.jpg";
import logo from "../../assets/tn-soft-logo.png";
import { RoutesUrl } from "../../common/consts/Routes";
import Ads from "../Ads/Ads";
import AdsList from "../Ads/AdsList";
import Avatars from "../Avatars/Avatars";
import NewAvatar from "../Avatars/NewAvatar";
import Clients from "../ClientsHub/Clients";
import NewClient from "../ClientsHub/NewClient";
import CredentialsForm from "../CredentialsForm/CredentialsForm";
import Gurus from "../Guru/Gurus";
import NewGuru from "../Guru/NewGuru";
import KeyWords from "../KeyWords/KeyWords";
import KeyWordsList from "../KeyWords/KeyWordsList";
import ParametricsProLIST from "../ParametricsPro/ParametricsProLIST";
import ParametricsProUI from "../ParametricsPro/ParametricsProUI";
import AccountMenu from "../shared/AccountMenu";
import SideMenu from "../shared/SideMenu";

const styles = ({ palette, breakpoints }: Theme) => {
	return createStyles({
		"@global": {
			"html, body, #root": {
				width: "100%",
				height: "100%",
			},
		},
		body: {
			height: "100%",
			backgroundColor: palette.background.default,
			[breakpoints.down("sm")]: {
				display: "block",
			},
			[breakpoints.up("sm")]: {
				"> *": {
					minHeight: "100%",
				},
			},
		},
		paper: {
			backgroundColor: palette.background.paper,
			padding: "1px",
			display: "flex",
			flexDirection: "column",
			justifyContent: "space-between"
		},
		content: {
			flex: 1,
			overflow: "auto",
		},
		default: {
			background: "#fff",
			padding: "1px 0px",
			"& img": {
				background: "#fff"
			}
		},
		footer: {
			"&  p": {
				fontsize: 14
			}
		},
		logos: {
			display: "block",
			margin: "0 auto 25px auto",
			width: "800px",
			maxWidth: "100%",
		},
	});
};

// eslint-disable-next-line @typescript-eslint/naming-convention
function Dashboard(props: RouteComponentProps & WithStyles): JSX.Element {
	const { classes } = props;

	const { t } = useTranslation();
	return (
		<Grid container className={classes.body} wrap="nowrap">
			<Box className={`${classes.paper} noPrint`}>
				<Box>
					{/* TO DO: */}
					{/* Img height used to be 90px */}
					<Box className={classes.default}>
						<img src={logo} alt="logo" style={{
							height: 100,
							margin: "20px auto 10px",
							display: "block",
						}} />
					</Box>
					<AccountMenu />
					<Hidden smDown>
						<Box paddingX="12px"><Divider variant="fullWidth" color="primary" /></Box>
						<SideMenu />
					</Hidden>
				</Box>
				<Box padding={2} className={classes.info} sx={{ maxWidth: "100%" }}>
					<Typography variant="caption"  >
						{t(`${TranslationPrefixes.footer}producedTitle`)}
						<br />
						{t(`${TranslationPrefixes.footer}serialNumber`)}
					</Typography>
				</Box>
			</Box>

			<Box padding="17px 20px" overflow="auto" flex="auto">

				<Switch>
					{/* --- CLIENTS HUB - routes: --- : */}
					{/* ... */}
					{/* <Route path={RoutesUrl.clients.newClient} component={NewClient} /> */}
					<Route path={RoutesUrl.clients.list} component={Clients} />
					<Route path={RoutesUrl.clients.edit()} component={NewClient} />
					<Route path={RoutesUrl.clients.create} component={NewClient} />
					<Route path={RoutesUrl.avatars.list} component={Avatars} />
					<Route path={RoutesUrl.avatars.edit()} component={NewAvatar} />
					<Route path={RoutesUrl.avatars.create} component={NewAvatar} />
					<Route path={RoutesUrl.gurus.list} component={Gurus} />
					<Route path={RoutesUrl.gurus.edit()} component={NewGuru} />
					<Route path={RoutesUrl.gurus.create} component={NewGuru} />
					<Route path={RoutesUrl.parametricsPro.edit()} component={ParametricsProUI} />
					<Route path={RoutesUrl.parametricsPro.create} component={ParametricsProUI} />
					<Route path={RoutesUrl.parametricsPro.list} component={ParametricsProLIST} />

					<Route path={RoutesUrl.dashboard.orders} component={DashboardOrders} />
					<Route path={RoutesUrl.dashboard.products} component={DashboardProducts} />
					<Route path={RoutesUrl.dashboard.productsProfit} component={DashboardProductsProfit} />
					<Route path={RoutesUrl.dashboard.profitBreakdown} component={ProfitBreakdown} />
					<Route path={RoutesUrl.salesVisualisation.totalRevenue} component={TotalRevenue} />
					<Route path={RoutesUrl.salesVisualisation.netProfit} component={NetProfit} />
					<Route path={RoutesUrl.dashboard.reports} component={DashboardReports} />
					<Route path={RoutesUrl.dashboard.cogs} component={Cogs} />
					<Route path={RoutesUrl.ads.list} component={AdsList} />
					<Route path={RoutesUrl.reports.listings} component={AdsList} />
					<Route path={RoutesUrl.ads.create} component={Ads} />
					<Route path={RoutesUrl.ads.edit()} component={Ads} />
					<Route path={RoutesUrl.keyWords.list} component={KeyWordsList} />
					<Route path={RoutesUrl.credentialsForm} component={CredentialsForm} />
					<Route path={RoutesUrl.keyWords.create} component={KeyWords} />
					<Route path={RoutesUrl.keyWords.edit()} component={KeyWords} />
					<Route path={RoutesUrl.orders} component={Orders} />
					<Route path={RoutesUrl.reports.orders} component={DashboardOrders} />
					<Route path={RoutesUrl.dashboard.inventory} component={Inventory} />
					<Route path={RoutesUrl.reports.inventory} component={ReportInventory} />
					<Route path={RoutesUrl.reports.business} component={ReportBusiness} />
					<Route path={RoutesUrl.editor} component={HtmlEditor} />
					<Route path="*">
						<Redirect to={RoutesUrl.clients.list} />
					</Route>
				</Switch>
				<StatusBar />
				<Box sx={{ fontSize: "16px", marginTop: "50px", marginBottom: "30px" }}>

					<Box sx={{ fontSize: "16px", display: "flex", alignItems: "flex-end", marginTop: "50px", marginBottom: "30px" }}>
						<img src={logoFooter} height="50px" width="auto" style={{ marginRight: "30px" }}></img>
						<Typography>{t(`${TranslationPrefixes.footer}title`)}</Typography>
						<img src={twoImg} height="100px" width="auto" style={{ marginLeft: "30px" }}></img>
					</Box>
					<img src={logos} alt="logos" className={classes.logos} />
					<Typography align="center" style={{ marginBottom: 15 }}>ПРОГРАМА ЗА РАЗВИТИЕ НА СЕЛСКИТЕ РАЙОНИ 2014-2020
					</Typography>
					<Typography align="center" style={{ marginBottom: 15 }}>Европейски земеделски фонд за развитие на селските райони: Европа инвестира в селските райони
					</Typography>
				</Box>
			</Box>

		</Grid>
	);
}

export default withRouter(withStyles(styles)(Dashboard));
